import VueRouter from "vue-router";

// Home section
import Home from "../components/home/Home.vue";

// About section

import About from "../components/about/About.vue";
import Biography from "../components/about/Biography.vue";
import CV from "../components/about/CV.vue";

// Outreach section

import Outreach from "../components/outreach/Outreach.vue";
import K12Stem from "../components/outreach/K12Stem.vue";
import MentoringAdvice from "../components/outreach/MentoringAdvice.vue";
import WomenInRobotics from "../components/outreach/WomenInRobotics.vue";

// Research section
import Research from "../components/research/Research.vue";
import ProjectPage from "../components/research/ProjectPage.vue";
import Areas from "../components/research/Areas.vue";
import Domains from "../components/research/Domains.vue";
import Projects from "../components/research/Projects.vue";
import Publications from "../components/research/Publications.vue";
import Teaching from "../components/research/Teaching.vue";
import Sponsors from "../components/research/Sponsors.vue";

// Administration section
import Administration from "../components/administration/Administration.vue";

// Media section
import Media from "../components/media/Media.vue";
import MediaCoverage from "../components/media/MediaCoverage.vue";
import Videos from "../components/media/Videos.vue";

// Contact section
import Contact from "../components/contact/Contact.vue";

// Edit Home section
import EditHome from "../edit_components/home/EditHome.vue";

// Edit About section
import EditPeople from "../edit_components/about/EditPeople.vue";
import EditRobots from "../edit_components/about/EditRobots.vue";
import EditAwards from "../edit_components/about/EditAwards.vue";
import EditFun from "../edit_components/about/EditFun.vue";

// Research section
import EditAreas from "../edit_components/research/EditAreas.vue";
import EditDomains from "../edit_components/research/EditDomains.vue";
import EditProjects from "../edit_components/research/EditProjects.vue";
import EditPublications from "../edit_components/research/EditPublications.vue";
import EditSponsors from "../edit_components/research/EditSponsors.vue";

// PhD Timeline page
import Timeline from "../components/utils/Timeline.vue"

// Edit Media section
import EditMediaCoverage from "../edit_components/media/EditMediaCoverage.vue";
import EditVideos from "../edit_components/media/EditVideos.vue";

// Edit Contact section
import EditContact from "../edit_components/contact/EditContact.vue";

// Signin section
// import Signin from "../components/auth/Signin.vue";

// Vuex store
import store from "../store/index";

// firebase
import { app } from "../utils/firebase";

const routes = [
  { path: "/", component: Home, name: "Home" },
  // { path: "/signin", component: Signin },
  { path: "/quit", redirect: "/home", name: "Quit Edit" },
  { path: "/home/edit", component: EditHome, name: "Edit Home" },
  { path: "/timeline", component: Timeline, name: "Timeline" },
  {
    path: "/about",
    component: About,
    children: [
     
      {
        path: "biography",
        component: Biography,
        name: "Biography",
      },
      {
        path: "cv",
        component: CV,
        name: "CV",
      },
      {
        path: "people/edit",
        component: EditPeople,
        name: "Edit People",
      },
      {
        path: "robots/edit",
        component: EditRobots,
        name: "Edit Robots",
      },
      {
        path: "awards/edit",
        component: EditAwards,
        name: "Edit Awards",
      },
      {
        path: "fun/edit",
        component: EditFun,
        name: "Edit Fun",
      },
    ],
  },
  {
    path: "/research",
    component: Research,
    children: [
      {
        path: "areas",
        component: Areas,
        name: "Areas",
      },

      {
        path: "domains",
        component: Domains,
        name: "Domains",
      },

      {
        path: "projects",
        component: Projects,
        name: "Projects",
      },
      {
        path: "publications",
        component: Publications,
        name: "Publications",
      },
      {
        path: "sponsors",
        component: Sponsors,
        name: "Sponsors",
      },
      {
        path: "teaching",
        component: Teaching,
        name: "Teaching",
      },
      {
        path: "areas/edit",
        component: EditAreas,
        name: "Edit Areas",
      },
      {
        path: "domains/edit",
        component: EditDomains,
        name: "Edit Domains",
      },
      {
        path: "projects/edit",
        component: EditProjects,
        name: "Edit Projects",
      },
      {
        path: "publications/edit",
        component: EditPublications,
        name: "Edit Publications",
      },
      {
        path: "sponsors/edit",
        component: EditSponsors,
        name: "Edit Sponsors",
      },
    ],
  },
  { path: "/project", component: ProjectPage, name: "project page redirect" },
  { path: "/project/:id", component: ProjectPage, name: "project page" },
  { path: "/administration", component: Administration, name: "Administration" },
  {
    path: "/media",
    component: Media,
    children: [
      {
        path: "media coverage",
        component: MediaCoverage,
        name: "Media Coverage",
      },
      {
        path: "videos",
        component: Videos,
        name: "Videos",
      },
      {
        path: "media coverage/edit",
        component: EditMediaCoverage,
        name: "Edit Media Coverage",
      },
      {
        path: "videos/edit",
        component: EditVideos,
        name: "Edit Videos",
      },
    ],
  },
  {
    path: "/outreach",
    component: Outreach,
    children: [
      {
        path: "K12Stem",
        component: K12Stem,
        name: "K-12 STEM",
      },
      {
        path: "MentoringAdvice",
        component: MentoringAdvice,
        name: "Mentoring Advice",
      },
      {
        path: "WomenInRobotics",
        component: WomenInRobotics,
        name: "Women In Robotics",
      },
    ],
  },
  { path: "/contact", component: Contact, name: "Contact" },
  { path: "/contact/edit", component: EditContact, name: "Edit Contact" },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

/**
 * router guard
 * prevent unauthenticated user to access edit page
 */
router.beforeEach((to, from, next) => {
  if (to.path.indexOf("/edit") !== -1) {
    if (app.auth().currentUser) {
      store.state.isEdit = true;
      localStorage.isEdit = true;
      next();
    } else next("/signin");
  } else {
    next();
  }
});

export default router;
